import { useRef } from "react";
import { useGlobalState } from "../globalState/GlobalStateProvider";
import { BiUserCircle } from "@react-icons/all-files/bi/BiUserCircle";
import { BiChevronDown } from "@react-icons/all-files/bi/BiChevronDown";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { MenuItem } from "primereact/menuitem";

const AZUL = "rgb(24, 52, 98)";

const TopbarUserInfo = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useGlobalState();
  const menu = useRef<Menu>(null);

  const abbr = () => {
    if (!state.user?.nomeUsuario) return "";

    const splited = state.user?.nomeUsuario.split(" ") || [];
    const first = splited[0];
    const last = splited[splited.length - 1];

    return `${first.substring(0, 1)}${last.substring(0, 1)}`.toUpperCase();
  };

  const handleLogout = () => {
    localStorage.removeItem("localState");
    window.location.href = "/app/login";
  };

  // Cabeçalho com avatar + nome, renderizado como item customizado do menu.
  const cabecalho = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "16px",
        backgroundColor: AZUL,
        color: "white",
      }}
    >
      <span
        style={{
          background: "rgba(255, 255, 255, 0.2)",
          borderRadius: "50%",
          width: "48px",
          height: "48px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: "16px",
          flexShrink: 0,
        }}
      >
        {abbr()}
      </span>
      <span style={{ fontWeight: 600, fontSize: "14px", lineHeight: "1.3" }}>
        {state.user?.nomeUsuario || ""}
      </span>
    </div>
  );

  const items: MenuItem[] = [
    // disabled apenas para tirar o cabeçalho da navegação por setas; como usa
    // template, não herda nenhum estilo de item desabilitado.
    { template: cabecalho, className: "topbar-user-header", disabled: true },
    {
      label: t("alterarSenha") as string,
      icon: "pi pi-key",
      command: () => navigate("/alterarsenha"),
    },
    {
      label: t("autenticacaoDoisFatores") as string,
      icon: "pi pi-shield",
      command: () => navigate("/autenticacao-dois-fatores"),
    },
    {
      label: t("chaveAcesso") as string,
      icon: "pi pi-id-card",
      command: () => navigate("/passkey"),
    },
    { separator: true },
    {
      label: t("logout") as string,
      icon: "pi pi-sign-out",
      className: "topbar-user-logout",
      command: handleLogout,
    },
  ];

  return (
    <div>
      <Button
        text
        className="button_usuario"
        style={{ color: "white", marginRight: "16px", border: "none", background: "transparent" }}
        aria-haspopup
        aria-controls="topbar_user_menu"
        onClick={(e) => menu.current?.toggle(e)}
      >
        {state.user?.nomeUsuario || ""}
        <BiUserCircle
          style={{ marginLeft: "8px", marginRight: "8px", marginTop: "-3px", fontSize: "20px" }}
        />
        <BiChevronDown style={{ fontSize: "20px", marginTop: "-3px" }} />
      </Button>
      <Menu
        id="topbar_user_menu"
        ref={menu}
        model={items}
        style={{ marginTop: "0.5rem" }}
        popup
        popupAlignment="right"
        className="topbar-user-menu"
      />
    </div>
  );
};

export default TopbarUserInfo;
